<template>
  <div id="app">
    <a  class="whatsApp"  target="_blank" @click="whatsApp"><div  class="my-whatsApp"><mdi-whatsapp></mdi-whatsapp><div class="loja" >POLO</div></div></a>
    <a  class="whatsApp2" target="_blank" @click="whatsApp2"><div  class="my-whatsApp"><mdi-whatsapp></mdi-whatsapp><div class="loja">CENTRO</div></div></a>
      <router-view/>
  </div>
</template>
<style lang="scss" scoped>
  @import "@/assets/scss/principal.scss";

</style>
<script>
export default {
  data: function(){

    return {
    }

  },
  methods:{
    whatsApp: function(){
      
      window.open("https://api.whatsapp.com/send?phone=5521996139634&text=Fale aqui, diretamente, com um vendedor da Casa Assuf.&source=&data=");
    },
    whatsApp2: function(){
      
      window.open("https://api.whatsapp.com/send?phone=5521996139311&text=Fale aqui, diretamente, com um vendedor da Casa Assuf.&source=&data=");
    },
  },
  mounted(){
  },
}
</script>
